import "../../styles/muiIcon.css";
import "../../styles/main.css";

export const MainComponent = ({ children }: any) => {
    return <>{children}</>;
};
